module.exports = __webpack_public_path__ + "img/ico4.bff3135f.png";